'use client'

import { Box } from '@mui/material'
import Link from '@/features/ref/components/Link'
import React from 'react'

interface InforCompanyProps {
  data: any
}
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faFacebook, faInstagram, faTiktok, faYoutube  } from '@fortawesome/free-brands-svg-icons'
// onClick={() => handleChangeMap(val?.maps)}
export const InforCompany = ({ data }: InforCompanyProps) => {
  return (
    <Box sx={{ width: '100%', overflow: 'hidden' }}>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.265498026724!2d106.65354957609546!3d10.790966089358706!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752ed189fa855d%3A0xf63e15bfce46baef!2sC%C3%B4ng%20ty%20TNHH%20-%20MONA%20MEDIA!5e0!3m2!1svi!2s!4v1761229833500!5m2!1svi!2s"
        width={2000}
        height={600}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        style={{ width: '100%', border: 0, minHeight: 450 }}
      />
    </Box>
  )
}
